import type { ServiceAreasPageLocations } from '@/types/ga4/tracking-locations'

export const SERVICE_AREAS_MAIN_LOCATION = 'service_areas_main'
export const SERVICE_AREAS_HERO_LOCATION = 'service_areas_hero'
export const SERVICE_AREAS_CTA_BANNER_LOCATION = 'service_areas_cta_banner'

export const SERVICE_AREAS_PAGE_LOCATIONS = {
	main: SERVICE_AREAS_MAIN_LOCATION,
	hero: SERVICE_AREAS_HERO_LOCATION,
	ctaBanner: SERVICE_AREAS_CTA_BANNER_LOCATION
} as const satisfies ServiceAreasPageLocations
